/**
 * 坐标格式转换工具函数
 */

/**
 * 将十进制经纬度转换为度分秒格式
 * @param {number} decimal 十进制经纬度
 * @returns {string} 度分秒格式字符串
 */
export function decimalToDMS(decimal) {
  if (decimal === null || decimal === undefined || isNaN(decimal)) {
    return '未知';
  }
  
  const absolute = Math.abs(decimal);
  const degrees = Math.floor(absolute);
  const minutesDecimal = (absolute - degrees) * 60;
  const minutes = Math.floor(minutesDecimal);
  const seconds = Math.floor((minutesDecimal - minutes) * 60);
  
  // 个位数的度和分前面补零
  const degreesStr = degrees < 10 ? `0${degrees}` : `${degrees}`;
  const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const secondsStr = seconds < 10 ? `0${seconds}` : `${seconds}`;
  
  return `${degreesStr}°${minutesStr}'${secondsStr}"`;
}

/**
 * 格式化纬度为度分秒格式，包含南北方向
 * @param {number} decimal 十进制纬度
 * @returns {string} 格式化后的纬度
 */
export function formatLatitude(decimal) {
  if (decimal === null || decimal === undefined || isNaN(decimal)) {
    return '未知';
  }
  
  const direction = decimal >= 0 ? 'N' : 'S';
  return `${decimalToDMS(Math.abs(decimal))}${direction}`;
}

/**
 * 格式化经度为度分秒格式，包含东西方向
 * @param {number} decimal 十进制经度
 * @returns {string} 格式化后的经度
 */
export function formatLongitude(decimal) {
  if (decimal === null || decimal === undefined || isNaN(decimal)) {
    return '未知';
  }
  
  const direction = decimal >= 0 ? 'E' : 'W';
  return `${decimalToDMS(Math.abs(decimal))}${direction}`;
} 